'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _itemScreenReaderDescription = require('../../item-screen-reader-description');

var _itemScreenReaderDescription2 = _interopRequireDefault(_itemScreenReaderDescription);

require('../styles/MoveButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MoveButton = function (_BcReactComponent) {
  _inherits(MoveButton, _BcReactComponent);

  function MoveButton(props) {
    _classCallCheck(this, MoveButton);

    var _this = _possibleConstructorReturn(this, (MoveButton.__proto__ || Object.getPrototypeOf(MoveButton)).call(this, props));

    _this.bindAll('handleClick');
    return _this;
  }

  _createClass(MoveButton, [{
    key: 'handleClick',
    value: function handleClick() {
      this.props.handleMove(this.props.item);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          direction = _props.direction,
          disabled = _props.disabled,
          item = _props.item;

      return _react2.default.createElement(
        _baseButtons.PrimaryGhostButton,
        {
          ghost: true,
          disabled: disabled,
          className: 'cp-move-button ' + className,
          'data-test-id': 'button-move-' + direction,
          handleClick: this.handleClick },
        direction === 'up' ? _react2.default.createElement(_baseIcons.Arrows.fontAwesome.Up, null) : _react2.default.createElement(_baseIcons.Arrows.fontAwesome.Down, null),
        _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'user_list_move_item_' + direction,
            values: { item: _react2.default.createElement(_itemScreenReaderDescription2.default, { item: item }) } })
        )
      );
    }
  }]);

  return MoveButton;
}(_baseBcReactComponent2.default);

exports.default = MoveButton;


MoveButton.propTypes = {
  className: _react.PropTypes.string,
  direction: _react.PropTypes.string,
  disabled: _react.PropTypes.bool,
  item: _bcPropTypes.listItemShape.isRequired,
  handleMove: _react.PropTypes.func.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/move-button/components/MoveButton.component.js
// module id = 1320
// module chunks = 0